<template>
  <v-layout row wrap v-if="userData">
    <v-flex xs6 offset-3>
      <v-card outlined flat>
        <v-card-title>
          My profile
          <v-spacer></v-spacer>
          <span style="color:blue;">{{userData.email}}</span>
          
        </v-card-title>
        <v-card-text>
          <v-flex xs10 offset-1>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field label="Name:" 
                  style="margin:10px"
                  :rules="nameRules"
                  v-model="userData.name"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Surname:" 
                  style="margin:10px"
                  :rules="nameRules"
                  v-model="userData.surname"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Nickname:" 
                  style="margin:10px"
                  v-model="userData.nickname"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Group/university:" 
                  style="margin:10px"
                  v-model="userData.groups"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                  style="margin:10px"
                  v-model="country"
                  :items="myCountries"
                  label="Country:"
                >Select country</v-select>
              </v-flex>
              <v-flex xs12>
              <v-select
                  style="margin:10px"
                  v-model="lang"
                  :items="myLanguages"
                  label="Environment language:"
                >Select environment language</v-select>
              </v-flex>
              <v-flex xs12>
                <v-slider
                    style="margin:10px"
                    v-model="userData.yob"
                    :rules="rules.age"
                    :label="getAge()"
                    hint="Be honest, please."
                    :min="1940"
                    :max="endYear"
                    thumb-label
                  ></v-slider>
              </v-flex>
          <v-flex xs12>
            <p align="center" v-if="feedback" style="color: red">{{feedback}}</p>
          </v-flex>
          <v-flex xs2 offset-10>
            <v-btn @click="saveChanges()">Save changes</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      </v-card-text>
        
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from '../../axios-auth.js'
// import {mapGetters} from 'vuex'

  export default {
    data () {
      return {
        feedback: '', 
        languages: null,
        age: 0,
        myLanguages: [],
        nameRules: [
            v => !!v || 'The value is required',
            v => (v && v.length >= 2 && v.length <= 40) || 'The value must be 2-40 characters',
          ],          
        lang: '',
        countries: null,
        myCountries: [],
        country: '',
        endYear: 0,
        show1 : false,
        userData: null,
        rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 5 || 'Min 5 characters'
        }
      }
    },
    methods: {
      saveChanges () {
        this.$store.commit('setFeedback', null)
        this.feedback = null
        if (this.userData.name.length < 2) { 
          this.feedback = "Name is too short." 
          return 
        }
        if (this.userData.surname.length < 2) {
          this.feedback = "Surname is too short."
          return
        }

        if (this.userData.yob == 1940) {
          this.feedback = "Please set your age - content is dependent on age too."
          return
        }  

        var _nick = this.userData.nickname
        if (_nick.length < 2) _nick = this.userData.name + " " + this.userData.surname
        var _country = this.countries[this.myCountries.indexOf(this.country)].id
        var _lang = this.languages[this.myLanguages.indexOf(this.lang)].id

        const data = {
          name: this.userData.name,
          surname : this.userData.surname,
          country :  _country,
          lang: _lang,
          nick: _nick,
          group: this.userData.groups,
          age: this.userData.yob
        }

        axios.post('/profile-change', data, this.$store.getters.getAxiosConfig)
          .then((response) => {
            if (response.data.message == 'OK') { 
              this.feedback = "Data saved."             
              axios.get('/get-profile-data', this.$store.getters.getAxiosConfig)
                  .then((response) => {
                    this.userData = response.data
                    })
                  .catch(error => {
                      this.feedback = error.message 
                  })  
            }          
           })
          .catch(error => {
              this.feedback = error.message 
          })
      },
      initData() {
        var d = new Date()
        this.endYear = d.getFullYear()

        this.$store.commit('setFeedback', null)
        axios.get('/languages', this.$store.getters.getAxiosConfig)
        .then((response) => {
          this.languages = response.data
          this.myLanguages = []
          for(let i = 0; i < this.languages.length; i++) {
            this.myLanguages.push( this.languages[i].name)
          }
          this.lang = this.myLanguages[0]
          axios.get('/countries', this.$store.getters.getAxiosConfig)
          .then((response) => {
            this.countries = response.data
            this.myCountries = []
            for(let i = 0; i < this.countries.length; i++) {
              this.myCountries.push( this.countries[i].country_name)
            }
            this.country = this.myCountries[0]
                  axios.get('/get-profile-data', this.$store.getters.getAxiosConfig)
                  .then((response) => {
                    this.userData = response.data
                    // find country 
                    for(let x = 0; x < this.countries.length; x++) {
                      if (this.countries[x].id == this.userData.country_id) {
                        this.country = this.myCountries[x]
                        break
                      }
                    }
                    // find lang                                      
                    for(let x = 0; x < this.languages.length; x++) {
                      if (this.languages[x].id == this.userData.pref_lang_id) {
                        this.lang = this.myLanguages[x]
                        break
                      }
                    }


                  })
                  .catch(error => {
                    this.$store.commit('setFeedback', error)          
                  })
          })
          .catch(error => {
            this.$store.commit('setFeedback', error)          
          })
        })
        .catch(error => {
          this.$store.commit('setFeedback', error)          
        })
      },
      getAge() {
        return "Y.of birth: " + this.userData.yob
      }
    },
    mounted() {
      this.initData()
    }
  }
</script>


<style>

</style>
